import React, { createContext, useState } from 'react';
import styled from 'styled-components';
import './ContentBarTabs.scss';
// movie charts
import CustomChart from '../../Charts/Movie/TopRatedChart/TopRatedChart';
import TrendingChart from '../../Charts/Movie/TrendingChart/TrendingChart';
import PopularChart from '../../Charts/Movie/PopularChart/PopularChart';
import NowPlayingChart from '../../Charts/Movie/NowPlayingChart/NowPlayingChart';

// movie charts
import CustomTvChart from '../../Charts/TV/TopRatedChart/TopRatedChart';
import PopularTvChart from '../../Charts/TV/PopularChart/PopularChart';
import AiringTodayTvChart from '../../Charts/TV/AiringTodayTvChart/AiringTodayTvChart';

const TabContext = createContext();
const TabConsumer = TabContext.Consumer;
const TabProvider = TabContext.Provider;

const Tabs = ({ children }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const selectTabIndex = activeIndex => {
    setActiveIndex(activeIndex);
  };

  const getContext = () => {
    return {
      activeIndex: activeIndex,
      onSelectTab: selectTabIndex
    };
  };

  return (
    <TabProvider value={getContext()}>
      <div className="contentBar-tabs">{children}</div>
    </TabProvider>
  );
};

const TabList = ({ children }) => {
  return (
    <TabConsumer>
      {context => {
        const { activeIndex } = context;
        const tabListChildren = React.Children.map(children, (child, index) => {
          return React.cloneElement(child, {
            isActive: index === activeIndex,
            onSelect: () => context.onSelectTab(index)
          });
        });
        return <div className="contentBar-tabs-list">{tabListChildren}</div>;
      }}
    </TabConsumer>
  );
};

const Tab = ({ isActive, isDisabled, onSelect, children }) => {
  return (
    <div
      className={
        isDisabled
          ? 'single-tab disabled'
          : isActive
            ? 'single-tab active'
            : 'single-tab'
      }
      onClick={isDisabled ? null : onSelect}>
      {children}
    </div>
  );
};

const TabPanels = ({ children }) => {
  return (
    <TabContext.Consumer>
      {context => {
        const { activeIndex } = context;
        return <div className="panels">{children[activeIndex]}</div>;
      }}
    </TabContext.Consumer>
  );
};

const TabPanel = ({ children }) => {
  return children;
};

const ChartsWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  /*  grid-template-columns: 1fr 1fr; */
`;

const SingleChartWrapper = styled.div`
  text-align: center;
`;

export const StatsTabs = () => (
  <Tabs>
    <TabList>
      <Tab>Movies</Tab>
      <Tab>TV</Tab>
    </TabList>
    <TabPanels>
      <TabPanel>
        <ChartsWrapper>
          <SingleChartWrapper>
            <h2>Top Rated</h2>
            <CustomChart />
          </SingleChartWrapper>
          <SingleChartWrapper>
            <h2>Trending</h2>
            <TrendingChart />
          </SingleChartWrapper>
          <SingleChartWrapper>
            <h2>Popular</h2>
            <PopularChart />
          </SingleChartWrapper>
          <SingleChartWrapper>
            <h2>Now Playing</h2>
            <NowPlayingChart />
          </SingleChartWrapper>
        </ChartsWrapper>
      </TabPanel>
      <TabPanel>
        <ChartsWrapper>
          <SingleChartWrapper>
            <h2>Top Rated</h2>
            <CustomTvChart />
          </SingleChartWrapper>
          <SingleChartWrapper>
            <h2>Popular</h2>
            <PopularTvChart />
          </SingleChartWrapper>
          <SingleChartWrapper>
            <h2>Airing Today</h2>
            <AiringTodayTvChart />
          </SingleChartWrapper>
        </ChartsWrapper>
      </TabPanel>
    </TabPanels>
  </Tabs>
);

export const FavsTabs = () => (
  <Tabs>
    <TabList>
      <Tab>Movies</Tab>
      <Tab>TV</Tab>
    </TabList>
    <TabPanels>
      <TabPanel>
        <ChartsWrapper>
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Maiores
          fugit autem provident asperiores, asdasdsunt adipisci tempora esse
          expedita nihil soluta itaque quibusdam. Reiciendis recusandae alias
          pariatur excepturi ex, veritatis aliquam.
        </ChartsWrapper>
      </TabPanel>
      <TabPanel>
        <ChartsWrapper>
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Maiores
          fugit autem provident asperiores, sunt adipisci tempora esse expedita
          nihil soluta itaque quibusdam. Reiciendis recusandae alias pariatur
          excepturi ex, veritatis aliquam.
        </ChartsWrapper>
      </TabPanel>
    </TabPanels>
  </Tabs>
);
